document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".shopify-section--header");

  if (!header) return;

  function updateHeader() {
    if (window.scrollY > 40) {
      header.classList.add("kairos-header-scrolled");
    } else {
      header.classList.remove("kairos-header-scrolled");
    }
  }

  updateHeader();
  window.addEventListener("scroll", updateHeader);
});

function initKairosTimeAnimations() {
  const timeSections = document.querySelectorAll('.kairos-time');

  if (!timeSections.length) return;

  const observer = new IntersectionObserver(
    (entries, observerInstance) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('is-visible');
        observerInstance.unobserve(entry.target);
      });
    },
    {
      threshold: 0.15
    }
  );

  timeSections.forEach((section) => {
    if (!section.classList.contains('is-visible')) {
      observer.observe(section);
    }
  });
}

document.addEventListener('DOMContentLoaded', initKairosTimeAnimations);

document.addEventListener('shopify:section:load', initKairosTimeAnimations);

window.addEventListener('load', initKairosTimeAnimations);